<!--
 * User Dropdown
 * --------------------------------------------------
 * Renders the user dropdown.
 *
 * @author Harvinder Singh
 * @created 2025-10-24
 -->

 <template>
  <TheUserDropdown
    :items="userItems"
    :username="userStore.username"
    @logout="userStore.logout"
  />
</template>

<script setup lang="ts">
import { TheUserDropdown, useTimezoneTime } from '@maropost-ui/liquidsky-ui'
import { useUserStore } from '@/lib/stores'
import useUserDropdownMenu from '@/lib/composable/usermenu/userDropdownMenu'

const props = withDefaults(defineProps<{
  /** timezone e.g. UTC, EST, etc. */
  timezone?: string
}>(), {
  timezone: 'UTC'
})
const { displayTime } = useTimezoneTime(props.timezone)


/* --------------------------------------------------
 * Store
 * --------------------------------------------------
 */
const userStore = useUserStore()

/* --------------------------------------------------
 * Reactive Menu (AUTO-UPDATES ON ACCESS CHANGE)
 * --------------------------------------------------
 */
const userItems = useUserDropdownMenu()
</script>

<style class="scoped">
  .time-block {
    font-size: 12px;
    font-weight: 400;
    color: #74767d;
    display: flex;
  }
</style>